import { useAuth } from "../../../utils/authContext";
import DbCustomer from './dbCustomer';
import DbInvoice from './dbInvoice';
import DbAppointment from './dbAppointment';
import './dashboard.css';
import { useState } from "react";

function Dashboard() {
    const { user } = useAuth() || {};
    const userName = user.prename;
    const [selectedKunde, setSelectedKunde] = useState(null);

    const kunden = [
        { id: 1, name: 'Max Mustermann', firma: 'Muster GmbH' },
        { id: 2, name: 'Erika Musterfrau', firma: 'Design Studio' }
    ];

    return (
        <div className='pageContainer'>
            <h1>Dashboard</h1>
            <h2>Willkommen {userName}!</h2>
            <div className="dashboardContainer">
                <div className="dashboardHeader">
                    <DbCustomer />
                    <DbInvoice/>
                </div>
                <DbAppointment/>

                {/* <Select 
                    items={kunden} 
                    selected={selectedKunde} 
                    setSelected={setSelectedKunde} 
                    displayKey="name" 
                /> */}
            </div>
        </div>
    );
}

export default Dashboard;